import { render, staticRenderFns } from "./AdminTipiOspiteView.vue?vue&type=template&id=e1c4e900&"
import script from "./AdminTipiOspiteView.vue?vue&type=script&lang=ts&"
export * from "./AdminTipiOspiteView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports